import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import type { BillingPlanId } from "@/services/api/billingService"
import { PLAN_COPY } from "./planCopy"

/** "Plans", or "Plans › Pro" during checkout, like the settings breadcrumb. */
export const UpgradeBreadcrumb: React.FC<{
  plan?: BillingPlanId
  /** Left out while a payment runs: "Plans" is then plain text. */
  onBackToPlans?: () => void
}> = ({ plan, onBackToPlans }) => {
  const { translate } = useTranslation()
  const title = translate("UPGRADE/PAGE_TITLE")
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          {plan && onBackToPlans ? (
            <BreadcrumbLink asChild>
              <button type="button" onClick={onBackToPlans}>
                {title}
              </button>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage>{title}</BreadcrumbPage>
          )}
        </BreadcrumbItem>
        {plan && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>{translate(PLAN_COPY[plan].name)}</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
